import type { KYCQuestionDefinition } from '@anchorage/graphql/generated';
import type { CustomLinkProps } from '@anchorage/utils';
import { parseSanitize } from '@anchorage/utils';
import { Modal } from '@latitude/modal';
import { Text } from '@latitude/text';
import { Question } from 'components/Question';
import type { ComponentType } from 'react';

import css from './styles.module.css';

type Props = {
  title: string;
  subtitle?: string;
  onModalClose: () => void;
  isModalOpen: boolean;
  groupQuestions: KYCQuestionDefinition[];
  groupNameAndIndex: string;
  groupId: string;
  isGroupDisabled: boolean;
  answeredOptions: Record<string, string>;
  CustomLink?: ComponentType<CustomLinkProps>;
  trackFn?: (questionId: string) => void;
};

const GroupModal = ({
  title,
  subtitle,
  onModalClose,
  isModalOpen,
  groupQuestions,
  groupNameAndIndex,
  groupId,
  isGroupDisabled,
  answeredOptions,
  CustomLink,
  trackFn = () => {},
}: Props) => {
  return (
    <Modal
      size="small"
      title={title}
      isOpen={isModalOpen}
      onClose={onModalClose}
      primaryAction={{
        htmlType: 'button',
        label: 'Done',
        onClick: onModalClose,
      }}
    >
      <div className={css.groupModalQuestions}>
        <Text className={css.groupModalSubtitle} variant="bodyRegular">
          {parseSanitize(subtitle, CustomLink)}
        </Text>
        {groupQuestions.map(({ id, ...props }) => {
          const questionName = `${groupNameAndIndex}.${id}`;
          return (
            <Question
              isDisabled={isGroupDisabled}
              key={`${groupId}-${questionName}`}
              question={{ ...props, id: questionName }}
              answeredOptions={answeredOptions}
              groupNameAndIndex={groupNameAndIndex}
              CustomLink={CustomLink}
              trackFn={trackFn}
            />
          );
        })}
      </div>
    </Modal>
  );
};

export { GroupModal };
